import { Divider, Grid } from "@material-ui/core";
import { LabelRow } from "@components/LabelEditor/components/LabelRow";
import { AddButtonFull } from "@components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { arrayOf, func, string } from "prop-types";
import { MAX_LABEL_LENGTH } from "@utils";

export const NewLabelRow = ({
  onCreate,
  ...colorProps
}) => {
  const {t} = useTranslation();
  
  const [editorVisible, showEditor] = useState(false);
  
  const showNewProjectTypeRow = () => {
    showEditor(true);
  }
  
  const handleCreate = (...data) => {
    onCreate(...data);
    showEditor(false);
  }
  
  return (
    <Grid item container>
      <Divider className="w-full my-3" />
      {
        editorVisible
          ? <LabelRow
            isNew
            maxLength={MAX_LABEL_LENGTH}
            onCreate={handleCreate}
            onCancel={() => showEditor(false)}
            { ...colorProps }
          />
          : <AddButtonFull onClick={showNewProjectTypeRow}>
            {t("views.settings.projects.labels.add_label")}
          </AddButtonFull>
      }
    </Grid>
  )
}

NewLabelRow.propTypes = {
  onCreate: func.isRequired,
  additionalColors: arrayOf(string).isRequired,
  additionalFontColors: arrayOf(string).isRequired,
  onAdditionalColorAdd: func.isRequired,
  onAdditionalFontColorAdd: func.isRequired,
}